import { render, staticRenderFns } from "./V-Brand.vue?vue&type=template&id=45d55a92&"
import script from "./V-Brand.vue?vue&type=script&lang=ts&"
export * from "./V-Brand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports